module.exports = __webpack_public_path__ + "img/W-G42.05e4775e.jpg";